export const getActiveTab = (state) => state.activeTab;
